import AdmissionChecklistScreen from "app/screens/pendingSignOffs/AdmissionChecklistScreen";

export default function AdmissionChecklistPage() {
  return <AdmissionChecklistScreen />;
}
